import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';
import { useUploadQueue } from '@/features/upload-queue';

/**
 * 带未上传提醒的退出登录。
 *
 * 手机多人共用，token 不落盘（CR-003），所以退出后本地队列里
 * A 的待传数据谁也传不了 —— 只有 A 本人再次登录才能续传。
 * 这个后果必须在退出前讲清楚，不能让工人以为照片已经安全了。
 */
export function useLogout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);
  const queue = useUploadQueue();

  const outstanding = queue.pending + queue.uploading + queue.failed;

  return useCallback(async () => {
    const message =
      outstanding > 0
        ? t('queue.logoutWarning', { count: outstanding })
        : t('auth.logoutConfirm');
    if (!window.confirm(message)) return;

    await logout('manual');
    navigate('/login', { replace: true });
  }, [logout, navigate, outstanding, t]);
}
